import { render, staticRenderFns } from "./brigada-prevencion-capacitacion-editar.vue?vue&type=template&id=13b46952&"
import script from "./brigada-prevencion-capacitacion-editar.vue?vue&type=script&lang=js&"
export * from "./brigada-prevencion-capacitacion-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports